export const station_closed = 'station_closed'
export const station_changed = 'station_changed'

export const NOTICE_SETTING_LIST = [
  {
    key: 'delivered',
    i18Key: 'enums.logisticStatus.2',
    statusDetailsI18Key: 'noticeSetting.email.shipped',
  },
  {
    key: 'arrived',
    i18Key: 'enums.logisticStatus.24002',
    statusDetailsI18Key: 'noticeSetting.email.deliveryStatusArrived',
  },
  {
    key: 'received',
    i18Key: 'enums.logisticStatus.3',
    statusDetailsI18Key: 'noticeSetting.email.received',
  },
  {
    key: station_closed,
    i18Key: 'order.storeClosed',
    statusDetailsI18Key: 'noticeSetting.email.received',
  },
  {
    key: station_changed,
    i18Key: 'order.storeChange',
    statusDetailsI18Key: 'noticeSetting.email.received',
  },
]

export const NOTICE_SETTING_LIST_MAP = NOTICE_SETTING_LIST.reduce((pre, cur) => {
  pre[cur.key] = cur.i18Key
  return pre
}, {} as Record<string, string>)
